import BioAreas from "./bio_areas"

export function start() {
  window.BioAreas = BioAreas.instance()
}